import {IWayPointCreationSingleVoyage} from "@containers/singleVoyage/types/point";
import {IRouteInfoSingleVoyage} from "@containers/singleVoyage/types/route";
import {
    getRouteNameFromPointsMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/route/helpers/getRouteNameFromPointsMutateSingleVoyage";
import {
    getRouteDefaultPlanedEndMutateSingleVoyage,
    getRouteDefaultPlanedStartMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/route/helpers/getRouteDefaultDate";
import {IRouteInfoMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/types";


export const getInitialRouteInfoMutateSingleVoyage = ({
                                                          initialPoints,
                                                          initialRouteInfo
                                                      }: {
    initialPoints?: IWayPointCreationSingleVoyage[],
    initialRouteInfo?: IRouteInfoSingleVoyage,
} = {}): IRouteInfoMutateSingleVoyage => {
    if (initialRouteInfo) {
        return {
            ...initialRouteInfo,
        }
    }

    return {
        title: getRouteNameFromPointsMutateSingleVoyage(initialPoints),
        driverId: 0,
        deviceId: 0,
        plannedStart: getRouteDefaultPlanedStartMutateSingleVoyage(),
        plannedEnd: getRouteDefaultPlanedEndMutateSingleVoyage(),
        config: {
            onRouteControl: false,
            waypointOrderControl: false,
            notification: false,
        },
        status: 'READY_FOR_MANUAL_RUN'
    }
}
